<div class="monitor-container h-100 d-flex">

    @let customerDetails = details();

    <div class="flex-grow-1 align-content-center">
        <div class="d-flex justify-content-center">
            <div class="monitor-call-details p-3">
                @if (taskActive() && customerDetails.areReady) {
                    <div class="d-flex w-100">
                        <div class="me-4 mt-5">
                            <telxl-contact-icon 
                                [fullName]="customerDetails.fullName" 
                                [contactType]="contactUserOptions.EndCustomer"
                                [size]="contactUserSizes.Large" /> 
                        </div>

                        <div class="col text-white">
                            <div class="font-sm pb-4">Incoming CLI:</div>
                            <div class="font-xxl weight-medium pb-1">{{ customerDetails.number }}</div>
                            <div class="font-xlg pb-2">{{ customerDetails.fullName }}</div>
                            <div class="font-xl">{{ customerDetails.callTime | formatDuration }}</div>

                            <div class="mt-5">
                                <div class="d-flex flex-wrap align-items-center pb-1">
                                    <div class="col-5">Number Dialled:</div>
                                    <div class="col-6  font-lg">{{ customerDetails.numberDialled }}</div>
                                </div>
                                <div class="d-flex flex-wrap align-items-center pb-1">
                                    <div class="col-5">Queue Name:</div>
                                    <div class="col-6  font-lg">{{ customerDetails.queueName }}</div>
                                </div>
                                <div class="d-flex flex-wrap align-items-center pb-1">
                                    <div class="col-5">Service Name:</div>
                                    <div class="col-6 font-lg">{{ customerDetails.serviceName }}</div>
                                </div>
                                <div class="d-flex flex-wrap align-items-center pb-1">
                                    <div class="col-5">Call ID:</div>
                                    <div class="col-6  font-lg">{{ customerDetails.callId }}</div>
                                </div>
                            </div>
                        </div>
                    </div>  
                }  @else if (!taskActive()) {
                    <div class="d-flex justify-content-center">
                        <div class="rounded-circle monitor-call__headset-border">
                            <i class="fa-light fa-xl fa-headset monitor-call__headset"></i>
                        </div>                        
                    </div>

                    <div class="text-white mt-4">
                        <div class="font-xxlg text-center">This monitored call has ended</div>
                        <div class="font-xlg text-center mt-4">{{ monitoredCallDuration() | formatDuration }}</div>
                    </div>

                }
                @else {
                    <telxl-loading [size]="'3rem'"/>
                }
            </div>            
        </div>
    </div>    

    <div class="d-flex align-items-center px-2 py-5">
        <div class="offset-2 col-7 text-white font-lg">
            @if (customerDetails.areReady && taskActive()) {
                <div class="d-flex justify-content-center align-items-center monitor-call-notice">
                    <div>
                        <i class="fa-light fa-waveform-lines fa-2xl me-3"></i>
                    </div>
                    <span>You are only able to listen in to this call. The Agent and Customer will not hear you.</span>
                </div>                    
            }
        </div>
        <div class="col-3">
            <div class="d-flex justify-content-center">
                <telxl-button 
                    [colour]="'dark'" 
                    [active]="true"
                    (buttonClick)="stopCallMonitoring()">
                    <i class="fa-lg fa-light fa-magnifying-glass-waveform pe-1 pt-1"></i>
                    End Monitoring
                </telxl-button>
            </div>
        </div>
    </div>  
  

</div>
